import React from "react";
import { cn } from "@/lib/utils";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = "md", className }) => {
  const sizeClasses = size === "sm" ? "h-4 w-4 border-2" :
    size === "lg" ? "h-10 w-10 border-4" :
    "h-6 w-6 border-3";

  return (
    <div
      className={cn(
        "flex items-center justify-center",
        className
      )}
    >
      <div
        className={cn(
          "animate-spin rounded-full border-primary border-t-transparent",
          sizeClasses
        )}
        role="status"
      />
    </div>
  );
};

export default Loader;
